import DownloadGoogle from './DownloadGoogle';

export default DownloadGoogle;
